//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setStorage, storageKey } from '@/utils/storage';
import CollapseTransition from '@/utils/collapseTransition';

export default {
  components: {
    CollapseTransition,
  },

  data() {
    return {
      industrySort: [
        {
          name: '零售类',
          id: 1,
          industry: [
            { name: '零售行业' },
            { name: '服装鞋帽' },
            { name: '母婴行业' },
            { name: '生鲜秤重' },
            { name: '批发商贸' },
            { name: '其他' },
          ],
        },
        {
          name: '餐饮类',
          id: 2,
          industry: [
            { name: '餐饮行业' },
            { name: '茶饮咖啡' },
            { name: '烘焙行业' },
          ],
        },
        {
          name: '服务类',
          id: 3,
          industry: [
            { name: '美业休闲' },
            { name: '艺培行业' },
            { name: '宠物行业' },
            { name: '生活服务' },
          ],
        },
      ],
      activeIndustrySortId: 0,
      activeIndustryName: '',
    };
  },

  methods: {
    handleIndustryHeaderClick(item) {
      let { id } = item;
      this.activeIndustrySortId = this.activeIndustrySortId === id ? 0 : id;
    },
    handleIndustryItemClick(item) {
      let { name } = item;
      let industry = this.activeIndustryName === name ? '' : name;
      this.activeIndustryName = industry;

      this.$store.commit('SET_USER_FIELD', {
        value: industry,
        key: 'industry',
      });

      setStorage(storageKey.industry, industry);
      setTimeout(() => {
        this.$router.push('/step02');
      }, 150);
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/step/step01.vue